module.exports = __webpack_public_path__ + "static/media/jump.2dacb2d5.mp3";